module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('discount-form', {
    attrs: {
      "create": true
    },
    on: {
      "saved": _vm.editDiscount
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65e9435a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/discounts/DiscountCreate.vue
// module id = 545
// module chunks = 0